module.exports = {"DINTALK_API":true,"Service_API_URL":"https://emaooa.com/dingdingInterface","Client_APP_URL":"https://smallmis.emaooa.com/","dingdingAccessKey":"DingDingAccessKey_H5","fileBaseUrl":"https://emaooa.com","menuItem":{"T006":"/HR/Leave","T001":"/FD/purchase","T044":"/FD/borrowing","T043":"/FD/reimbursement","T042":"/FD/reimbursement","T053":"/FD/travelExpenses","T037":"/FD/invoice","T079":"/FD/personalReim","T065":"/BD/project","T066":"/BD/projectBudgetChange"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/develop.json
// module id = sxH1
// module chunks = 1